import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {informationPushes} = api

/**
 * 查找
 */
export async function findInformationPushes(params) {
    return request({url: informationPushes, method: 'get', data: params,})
}




// WEBPACK FOOTER //
// ./src/services/informationPushes.js